module.exports = __webpack_public_path__ + "img/compact.ef8d5e79.png";